import React, { useMemo } from 'react';
import moment from 'moment';
import { useIntl, getLocale } from 'umi';
import { Row, Col, Card } from 'tea-component';
import {
  upperFrist,
  getBgImg,
  platImg,
  getValue,
} from '@/pages/intelligence/pages/MarketProfile/_util';
import { formatNum, formatPercentNum } from '@/pages/intelligence/utils/commonUtils';
import Loading from '@/pages/intelligence/components/Loading';
import NoData from '@/pages/intelligence/components/NoData';
import TopGameList from '../../components/TopGameList';
import TipContext from '@/pages/home/components/TipContextComponents/TipContext';
import BlockbusterGamesCard from '@/pages/intelligence/components/CardComponents/BlockbusterGamesCard';
import { getDetailGamePathCommon } from '@/pages/intelligence/utils/topchartsUtils';
// import CardContext from '@/pages/intelligence/pages/MarketProfile/components/CardContext';
import OverviewCard from '@intelligence/components/OverviewCard';

// import MscienceIcon from '@/pages/intelligence/assets/svg/dataSource/mscience-bg.svg';
// import Npdicon from '@/pages/intelligence/assets/svg/dataSource/npd-icon.svg';
import DefaultImg from '@/pages/intelligence/assets/svg/flag/default.svg';
import xbox from '@/pages/intelligence/assets/svg/marketprofile/xbox.svg';
import playstation from '@/pages/intelligence/assets/svg/marketprofile/playstation.svg';
import nintendo from '@/pages/intelligence/assets/svg/marketprofile/nintendo.svg';

import './index.scss';

export default function ConsoleGameMarket(props: any) {
  const {
    summaryDataLoad,
    summaryTime,
    part1Data,
    part2Data,
    // part3Data,
    mainSegment,
    // actionFun,
    newGameData,
    newGameLoad,
    newGameDate,
    topGameDataLoad,
    topGameTime,
    topConsoleGame10,
    gotoStats,
    gotoGameDetailsPage,
  } = props || {};
  const { formatMessage } = useIntl();
  moment.locale(getLocale() === 'en-US' ? 'en' : 'zh-cn');

  const getHasSpace = () => {
    return getLocale() === 'en-US' ? ' ' : '';
  };

  // 将数据转换为卡片所需格式
  const formatLineData = (data: any) => ({
    dataType: 'month' as const,
    xAxisData: data?.xAxis,
    seriesData: data?.yAxis?.map((item: any) => item?.value),
  });

  const lineData1 = useMemo(() => formatLineData(part1Data), [part1Data]);
  const lineData2 = useMemo(() => formatLineData(part2Data), [part2Data]);

  const marketPerformanceData = [
    {
      // title: `${formatMessage({ id: 'dbi_console' })}${getHasSpace()}${formatMessage({
      //   id: 'dbi_metric_digitalRevenue',
      // })}`,
      // icon: MscienceIcon,
      // desc: moment(summaryTime).format('MMM, YYYY'),
      // num: part1Data.revenue == 0 ? '-' : formatNum(part1Data.revenue, true),
      // numtrend: formatPercentNum(part1Data.revenuePrecent),
      // text: `Rank ${part1Data.rank == 0 ? '-' : part1Data.rank}`,
      // textnum: part1Data.rankChange != 0 ? Math.abs(part1Data.rankChange) : '-',
      // istextUp: part1Data.rankChange != 0 ? part1Data.rankChange : '-',
      // isUp: part1Data.revenuePrecent >= 0,
      // chart: (
      //   <>
      //     {part1Data?.xAxis?.length == 0 || part1Data?.yAxis?.length == 0 ? (
      //       <div className="summaryNoData">
      //         <NoData height="100%" title="No trends data under current selections." />
      //       </div>
      //     ) : (
      //       <></>
      //     )}
      //     <div id={'mpOvSummaryRight' + 'PC Digital Revenue($)'} className="mpOvSummaryRight" />
      //   </>
      // ),
      // chartData: part1Data,

      titleContent: `${formatMessage({ id: 'dbi_console' })}${getHasSpace()}${formatMessage({
        id: 'dbi_metric_digitalRevenue',
      })}`,
      titleIcon: 'mscience',
      lineData: lineData1,
      baseIndicators: {
        indicatorsVal: part1Data.revenue === 0 ? '-' : formatNum(part1Data.revenue, true),
        rankVal: part1Data.rank,
        latestDate: moment(summaryTime).format('YYYY-MM'),
      },
      numArrowData: {
        numContent: formatPercentNum(part1Data.revenuePrecent),
        numSize: 'small',
        arrow: true,
        numColor: part1Data.revenuePrecent > 0 ? 'successColor' : 'errorColor',
        arrowColor: part1Data.revenuePrecent > 0 ? 'trendUp' : 'trendDown',
      },
      rankData: {
        numContent: part1Data.rankChange !== 0 ? Math.abs(part1Data.rankChange) : '-',
        numColor: 'grayColor',
        numSize: 'big',
        arrow: part1Data.rankChange !== 0,
        arrowColor: part1Data.rankChange > 0 ? 'grayUp' : 'grayDown',
      },
    },
    {
      // title: `${formatMessage({ id: 'dbi_console' })}${getHasSpace()}${formatMessage({
      //   id: 'dbi_metric_physical_revenue',
      // })}`,
      // icon: Npdicon,
      // desc: moment(summaryTime).format('MMM, YYYY'),
      // num: part2Data.revenue == 0 ? '-' : formatNum(part2Data.revenue, true),
      // numtrend: formatPercentNum(part2Data.revenuePrecent),
      // text: `Rank ${part2Data.rank == 0 ? '-' : part2Data.rank}`,
      // textnum: part2Data.rankChange != 0 ? Math.abs(part2Data.rankChange) : '-',
      // istextUp: part2Data.rankChange != 0 ? part2Data.rankChange : '-',
      // isUp: part2Data.revenuePrecent >= 0,
      // chart: (
      //   <>
      //     {part2Data?.xAxis?.length == 0 || part2Data?.yAxis?.length == 0 ? (
      //       <div className="summaryNoData">
      //         <NoData height="100%" title="No trends data under current selections." />
      //       </div>
      //     ) : (
      //       <></>
      //     )}
      //     <div id={'mpOvSummaryRight' + 'PC Physical Revenue($)'} className="mpOvSummaryRight" />
      //   </>
      // ),
      // chartData: part2Data,

      // 新组件参数属性
      titleContent: `${formatMessage({ id: 'dbi_console' })}${getHasSpace()}${formatMessage({
        id: 'dbi_metric_physical_revenue',
      })}`,
      titleIcon: 'npd',
      lineData: lineData2,
      baseIndicators: {
        indicatorsVal: part2Data.revenue === 0 ? '-' : formatNum(part2Data.revenue, true),
        rankVal: part2Data.rank,
        latestDate: moment(summaryTime).format('YYYY-MM'),
      },
      numArrowData: {
        numContent: formatPercentNum(part2Data.revenuePrecent),
        numSize: 'small',
        arrow: true,
        numColor: part2Data.revenuePrecent > 0 ? 'successColor' : 'errorColor',
        arrowColor: part2Data.revenuePrecent > 0 ? 'trendUp' : 'trendDown',
      },
      rankData: {
        numContent: part2Data.rankChange !== 0 ? Math.abs(part2Data.rankChange) : '-',
        numColor: 'grayColor',
        numSize: 'big',
        arrow: part2Data.rankChange !== 0,
        arrowColor: part2Data.rankChange > 0 ? 'grayUp' : 'grayDown',
      },
    },
  ];

  const BlockbusterGamesData = newGameData.map((item: any) => ({
    ...item,
    img: getBgImg(item),
    list: {
      entity_type: item?.entity_type,
      img: item.cover,
      gametitle: item.name,
      countryIcon: item.country_img || DefaultImg,
      text: item.publisher,
      icon: item.platform.split('|')?.map((obj: string) => {
        if (obj.toUpperCase() === 'PS') return playstation;
        if (obj.toUpperCase() === 'XBOX') return xbox;
        if (obj.toUpperCase() === 'NINTENDO') return nintendo;

        return '';
      }),
    },
    icon: platImg(item),
    desc: `${upperFrist(item?.chart_type || item?.chat_type)}${getValue(item)}`,
    title: `The description of the ${item.name}`,
    text: item.desc,
    linkUrl: getDetailGamePathCommon({
      entityType: item?.entity_type,
      gameId: item?.unified_id,
      tab: 'overview',
    }),
  }));

  return (
    <div className="dbi-marketoverview-console">
      <Card className="tabdetails-performance-summary">
        <Card.Body
          title={
            <div className="tabdetails-performance-felx">
              <span className="tabdetails-performance-felx-text">
                {formatMessage({ id: 'dbi_market_perf_sum' })}
              </span>
              <TipContext
                className="icon-top"
                tipText={formatMessage({ id: 'dbi_market_perf_sum_tip' })}
              />
            </div>
          }
        >
          <Row>
            {summaryDataLoad ? (
              <div style={{ width: '100%', height: 157 }}>
                <Loading content={formatMessage({ id: 'common_loading' })} />
              </div>
            ) : (
              marketPerformanceData.map((item: any, index: any) => {
                return (
                  // <Col span={24 / marketPerformanceData.length} key={index}>
                  //   <CardContext
                  //     data={item}
                  //     part1Data={part1Data}
                  //     getDetails={() => gotoStats(item.title)}
                  //   />
                  // </Col>
                  <Col span={24 / marketPerformanceData.length} key={index}>
                    <OverviewCard
                      {...item}
                      moduleName="marketProfile"
                      onClickJump={() => gotoStats(item.titleContent)}
                    />
                  </Col>
                );
              })
            )}
          </Row>
        </Card.Body>
      </Card>

      <Card className="tabdetails-top">
        <Card.Body
          title={
            <div className="tabdetails-gamehead">
              <div className="tabdetails-gamehead-title">
                <span className="tabdetails-gamehead-title-text">
                  {formatMessage({ id: 'dbi_market_blockbuster' })}
                </span>
                <TipContext
                  className="icon-top"
                  AWidth={430}
                  tipText={formatMessage({ id: 'dbi_market_blockbuster_console_tip' })}
                />
              </div>
              <div className="tabdetails-gamehead-text">
                {newGameDate ? moment(newGameDate).format('MMM, YYYY') : null}
              </div>
            </div>
          }
        >
          <Row>
            {/* eslint-disable-next-line no-nested-ternary */}
            {newGameLoad ? (
              <div style={{ width: '100%', height: 417 }}>
                <Loading content={formatMessage({ id: 'common_loading' })} />
              </div>
            ) : newGameData?.length === 0 ? (
              <div
                className="context-num"
                style={{ height: 417, width: '100%', justifyContent: 'center' }}
              >
                <NoData title="No data under current selections." />
              </div>
            ) : (
              BlockbusterGamesData.map((item: any, index: any) => {
                return (
                  <Col
                    span={BlockbusterGamesData.length === 1 ? 12 : 24 / BlockbusterGamesData.length}
                    key={index}
                  >
                    <BlockbusterGamesCard
                      data={item}
                      onClick={() => gotoGameDetailsPage(item, 'overview')}
                      onDescClick={() => gotoGameDetailsPage(item, 'storeRank')}
                    />
                  </Col>
                );
              })
            )}
          </Row>
        </Card.Body>
      </Card>

      <Row className="tabdetails-rowtop">
        <Col span={12}>
          {topGameDataLoad ? (
            <Card style={{ height: 1150, width: '100%' }}>
              <Loading content={formatMessage({ id: 'common_loading' })} />
            </Card>
          ) : (
            <TopGameList
              data={topConsoleGame10}
              gameType="console"
              title={
                <div className="tabdetails-gamehead-title">
                  {`Top 10 ${formatMessage({ id: 'dbi_console_games' })}`}
                  <TipContext
                    className="icon-top"
                    tipText={formatMessage({ id: 'dbi_market_perf_sum_tip' })}
                  />
                </div>
              }
              time={moment(topGameTime).format('MMM, YYYY')}
              needTitle={true}
              segmentType={'game'}
              containerId={'mpTopGameListChartTotalConsole'}
              needChart={true}
            />
          )}
        </Col>
        <Col span={12}>
          {topGameDataLoad ? (
            <Card style={{ height: 1150, width: '100%' }}>
              <Loading content={formatMessage({ id: 'common_loading' })} />
            </Card>
          ) : (
            <TopGameList
              data={topConsoleGame10}
              gameType="company"
              title={
                <div className="tabdetails-gamehead-title">
                  {`Top 10 ${formatMessage({ id: 'dbi_imur_GC' })}`}
                  <TipContext
                    className="icon-top"
                    tipText={formatMessage({ id: 'dbi_market_perf_sum_tip' })}
                  />
                </div>
              }
              time={moment(topGameTime).format('MMM, YYYY')}
              needTitle={true}
              segmentType={'company'}
              containerId={'mpTopGameListChartGameCompany'}
              parentType={mainSegment}
              needChart={true}
            />
          )}
        </Col>
      </Row>
    </div>
  );
}
